import { Message } from "../../BP2Components";
import { getLabelFromTechName } from "../../FormsV2/FormFields/QuestionnaireTableField/questionnarieTableScripts";

export const addIndexesToItems = (items, lastPrevListItemIndex) => {
   return items?.map((item, index) => ({
      ...item,
      index: lastPrevListItemIndex + index + 1,
   }));
};
export const findAndCompareObject = (list, object, number) => {
   if (number <= 0 || number > list.length) {
      return false;
   }

   const objectIndex = list.length - number;
   const objectFromList = list[objectIndex];

   return object.index === objectFromList.index;
};

export const findObjectWithMaxIndex = (items) => {
   if (items) {
      return items.reduce((maxIndexItem, currentItem) => {
         if (!maxIndexItem || currentItem.index > maxIndexItem.index) {
            return currentItem;
         }
         return maxIndexItem;
      }, null);
   }
};

export const handleActionRestrictions = (requestData) => {
   if (!requestData) {
      Message?.error("infinityList.requestDataInvalid");
      return requestData;
   }

   const filterHiddenActions = (actions) => {
      return actions?.filter((action) => !action.restrictions?.hidden);
   };

   // if needed just add here another function like: "filteredActions = handleSortingActions(filteredActions)"
   let filteredActions = requestData.actions;
   filteredActions = filterHiddenActions(filteredActions);

   return {
      ...requestData,
      actions: filteredActions,
   };
};
